import { FaAngleDoubleDown } from 'react-icons/fa';
import styled from 'styled-components';
import { deviceMax } from '../../../styles/MediaQuery';
import {
    darkGreen,
    greyBorderButton,
    greyLight,
    lightGraishButton,
    lightGray,
    lightGreyButton,
} from '../../../styles/Variables';

export const ResultWrapper = styled.div`
    margin-top: 2.5em;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 1.25em;
    width: 100%;
    padding-bottom: 5em;

    @media ${deviceMax.laptop} {
        grid-template-columns: 1fr 1fr;
    }

    @media ${deviceMax.tablet} {
        grid-template-columns: 1fr;
    }
`;

export const ItemBox = styled.div`
    display: flex;
    flex-direction: column;
    height: 300px;

    * {
        text-decoration: none;
    }
`;

export const ImageBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    height: 220px;
    background-color: ${greyLight};
    border: 1px solid ${greyBorderButton};
`;

export const ItemTitle = styled.h4`
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;

    &:hover {
        color: ${darkGreen};
    }
`;

export const ButtonBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Button = styled.button`
    font-size: 1rem;
    background: linear-gradient(${lightGreyButton}, ${lightGraishButton});
    color: ${darkGreen};
    border: 1px solid ${lightGray};
    min-width: 9.4em;
    padding: 0.75em 1.875em;
    border-radius: 5px;
    cursor: pointer;
    margin: 2rem 0;
    font-family: Arial, Helvetica, sans-serif;
`;

export const DownIcon = styled(FaAngleDoubleDown)`
    * {
        color: ${darkGreen};
    }
`;

export const ProductImg = styled.img`
    height: 100%;
`;
